(function () {
  'use strict';

  if (window.slWalletMatchingBeltsLoaded) return;
  window.slWalletMatchingBeltsLoaded = true;

  function initialize(root) {
    if (root.dataset.slInitialized === 'true') return;

    var form = root.closest('form');
    if (!form) return;

    // Use the customer's active storefront currency.
var currency = root.dataset.currency || 'CAD';


    var walletVariants;

    try {
      walletVariants = JSON.parse(root.dataset.walletVariants);
    } catch (error) {
      console.error('Matching belts: invalid wallet data.', error);
      return;
    }

    var walletContainer = root.querySelector('[data-sl-wallet-units]');
    var walletTemplate = root.querySelector(
      '[data-sl-wallet-unit-template]'
    );
    var trigger = root.querySelector('[data-sl-set-trigger]');
    var beltOptions = root.querySelector('[data-sl-belt-options]');
    var summary = root.querySelector('[data-sl-set-summary]');
    var errorBox = root.querySelector('[data-sl-set-error]');
    var beltCards = Array.from(
      root.querySelectorAll('[data-sl-belt-card]')
    );

    if (!walletContainer || !walletTemplate || !summary || !errorBox) {
      return;
    }

    var feeVariantId = Number(root.dataset.monogramVariantId);
   var feePrice =
  root.dataset.monogramPrice &&
  root.dataset.monogramPrice.trim() !== ''
    ? Number(root.dataset.monogramPrice)
    : NaN;

    var discountRate = Number(root.dataset.discountRate);

    if (
      !Number.isSafeInteger(feeVariantId) ||
      feeVariantId < 1 ||
      !Number.isFinite(feePrice) ||
      feePrice < 0 ||
      !Number.isFinite(discountRate) ||
      discountRate < 0 ||
      discountRate >= 1
    ) {
      return;
    }

    var busy = false;
    var walletStates = [];

    var formatter = new Intl.NumberFormat(
      document.documentElement.lang || 'en-CA',
      {
        style: 'currency',
        currency: currency
      }
    );

    function money(cents) {
   return formatter.format(cents / 100).replace(/CA\$/g, '$');

    }

    function cleanMonogram(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9.\- ]/g, '')
        .slice(0, 5);
    }

    function quantityValue() {
      var field = form.querySelector('[name="quantity"]');
      var quantity = field ? Number(field.value) : 1;

      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        return null;
      }

      return quantity;
    }

    function selectedWalletVariant() {
      var field = form.querySelector('[name="id"]');
      if (!field) return null;

      return walletVariants.find(function (variant) {
        return String(variant.id) === String(field.value);
      }) || null;
    }

    function selectedBelts() {
      return beltCards.filter(function (card) {
        return card.querySelector('[data-sl-belt-check]').checked;
      });
    }

    function walletUnits() {
      return Array.from(
        walletContainer.querySelectorAll('[data-sl-monogram-unit]')
      );
    }

    function showError(message) {
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function updateMonogramUnit(unit, enabled) {
      var checkbox = unit.querySelector('[data-sl-monogram-check]');
      var fields = unit.querySelector('[data-sl-monogram-fields]');
      var input = unit.querySelector('[data-sl-monogram-text]');
      var counter = unit.querySelector('[data-sl-monogram-counter]');
      var feeLabel = unit.querySelector('[data-sl-monogram-fee]');

      checkbox.disabled = !enabled;

      var active = enabled && checkbox.checked;

      fields.hidden = !active;
      input.disabled = !active;
      input.required = active;

      input.value = cleanMonogram(input.value);
      counter.textContent = input.value.length + '/5';
      feeLabel.textContent = '+' + money(feePrice);
    }

    function saveWalletStates() {
      walletUnits().forEach(function (unit, index) {
        walletStates[index] = {
          checked: unit.querySelector(
            '[data-sl-monogram-check]'
          ).checked,
          text: unit.querySelector(
            '[data-sl-monogram-text]'
          ).value
        };
      });
    }

   function synchronizeWalletUnits() {
  var quantity = quantityValue();
  if (quantity === null) return;

  var originalCheck = form.querySelector('#sl-checkbox');
  var originalInput = form.querySelector('#sl-input');

  var checked = Boolean(originalCheck && originalCheck.checked);
  var text = originalInput
    ? cleanMonogram(originalInput.value)
    : '';

  var existing = walletUnits();

  while (existing.length > quantity) {
    existing.pop().remove();
  }

  while (existing.length < quantity) {
    var fragment = walletTemplate.content.cloneNode(true);
    var unit = fragment.querySelector('[data-sl-monogram-unit]');

    walletContainer.appendChild(fragment);
    existing.push(unit);
  }

  existing.forEach(function (unit) {
    unit.querySelector('[data-sl-monogram-check]').checked = checked;
    unit.querySelector('[data-sl-monogram-text]').value = text;

    updateMonogramUnit(unit, true);
  });
}

    function discountPrice(cents) {
      return Math.round(cents * (1 - discountRate));
    }

    function countMonograms() {
      var count = 0;

      walletUnits().forEach(function (unit) {
        if (unit.querySelector('[data-sl-monogram-check]').checked) {
          count += 1;
        }
      });

      selectedBelts().forEach(function (card) {
        if (card.querySelector('[data-sl-monogram-check]').checked) {
          count += 1;
        }
      });

      return count;
    }

    function update() {
      var offerOpen = Boolean(
  trigger && trigger.getAttribute('aria-expanded') === 'true'
);

summary.hidden = !offerOpen;
var walletOfferPriceBox = root.querySelector(
  '.sl-ws-wallet-offer-price'
);

if (walletOfferPriceBox) {
  walletOfferPriceBox.hidden = !offerOpen;
}


var estimateNote = summary.nextElementSibling;

if (
  estimateNote &&
  estimateNote.matches('small.sl-ws-help')
) {
  estimateNote.hidden = !offerOpen;
}

      synchronizeWalletUnits();

      var selected = selectedBelts();
      var beltRegularTotal = 0;
      var beltPrices = [];
      var complete = true;

      beltCards.forEach(function (card) {
  var checked = card.querySelector('[data-sl-belt-check]').checked;
  var details = card.querySelector('[data-sl-belt-details]');
  var select = card.querySelector('[data-sl-belt-variant]');
  var priceBox = card.querySelector('[data-sl-belt-price]');
  var monogramUnit = card.querySelector('[data-sl-monogram-unit]');
  var savingsLabel = card.querySelector('[data-sl-belt-savings]');
  var selectedOption = select.options[select.selectedIndex];

  details.hidden = !checked;
  select.disabled = !checked;
  select.required = checked;

  updateMonogramUnit(monogramUnit, checked);

  var validSelection = Boolean(
    select.value &&
    selectedOption &&
    !selectedOption.disabled
  );

  // Preview the chosen option, or the first available option.
  // This does not select a size on the customer's behalf.
  var previewOption = validSelection
    ? selectedOption
    : Array.from(select.options).find(function (option) {
        return option.value && !option.disabled;
      });

  var previewPrice = previewOption
    ? Number(previewOption.dataset.price)
    : null;

  var validPreview =
    previewPrice !== null &&
    Number.isFinite(previewPrice);

  priceBox.hidden = !validPreview;

  if (validPreview) {
    var salePrice = discountPrice(previewPrice);
    var beltSavings = previewPrice - salePrice;

    card.querySelector('[data-sl-belt-sale]').textContent =
      money(salePrice);

    card.querySelector('[data-sl-belt-regular]').textContent =
      money(previewPrice);

    if (savingsLabel) {
      savingsLabel.textContent = 'Save ' + money(beltSavings);
    }
  } else if (savingsLabel) {
    savingsLabel.textContent = '';
  }

  // Only selected belts contribute to the estimated set total.
  if (!checked) return;

  if (!validSelection) {
    complete = false;
    return;
  }

  var selectedPrice = Number(selectedOption.dataset.price);

  if (!Number.isFinite(selectedPrice)) {
    complete = false;
    return;
  }

  beltRegularTotal += selectedPrice;
  beltPrices.push(selectedPrice);
});


      var quantity = quantityValue();
      var wallet = selectedWalletVariant();
      var walletOfferSale = root.querySelector('[data-sl-wallet-offer-sale]');
var walletOfferRegular = root.querySelector('[data-sl-wallet-offer-regular]');
var walletOfferSavings = root.querySelector('[data-sl-wallet-offer-savings]');

if (wallet) {
  var walletOfferPrice = Number(wallet.price);
  var walletOfferDiscounted = discountPrice(walletOfferPrice);

  if (walletOfferSale) {
    walletOfferSale.textContent = money(walletOfferDiscounted);
  }

  if (walletOfferRegular) {
    walletOfferRegular.textContent = money(walletOfferPrice);
  }

  if (walletOfferSavings) {
    walletOfferSavings.textContent =
      ' · Save ' + money(walletOfferPrice - walletOfferDiscounted);
  }
} else {
  if (walletOfferSale) walletOfferSale.textContent = '';
  if (walletOfferRegular) walletOfferRegular.textContent = '';
  if (walletOfferSavings) walletOfferSavings.textContent = '';
}

      var monogramCount = countMonograms();
      var monogramTotal = monogramCount * feePrice;

      if (quantity === null) {
        summary.textContent = 'Enter a valid wallet quantity.';
        return;
      }

      if (!wallet || !wallet.available) {
        summary.textContent = 'Choose an available wallet option.';
        return;
      }

      if (!complete) {
        summary.textContent =
          'Choose an available size / option for every selected belt.' +
          ' Monogramming selected: ' + money(monogramTotal) +
          ' for ' + monogramCount + ' item(s).';
        return;
      }

      // This preview counts only the items being added from this form.
      var qualifies = quantity + selected.length >= 2;
      var walletPrice = Number(wallet.price);

      var regularTotal =
        walletPrice * quantity + beltRegularTotal;

      var discountedProductTotal =
        (qualifies ? discountPrice(walletPrice) : walletPrice) *
        quantity;

      beltPrices.forEach(function (price) {
        discountedProductTotal += qualifies
          ? discountPrice(price)
          : price;
      });

      selected.forEach(function (card) {
        var select = card.querySelector('[data-sl-belt-variant]');
        var option = select.options[select.selectedIndex];
        var price = Number(option.dataset.price);

        card.querySelector('[data-sl-belt-sale]').textContent =
          money(qualifies ? discountPrice(price) : price);
      });

      var savings = regularTotal - discountedProductTotal;
      var estimatedTotal = discountedProductTotal + monogramTotal;

      summary.textContent =
  'Estimated total: ' + money(estimatedTotal) +
  '. Estimated Savings: ' + money(savings) + '.';

    }

    function validateMonogram(unit) {
      var checkbox = unit.querySelector('[data-sl-monogram-check]');
      var input = unit.querySelector('[data-sl-monogram-text]');

      if (!checkbox.checked) return '';

      input.value = cleanMonogram(input.value);
      var text = input.value.trim();

      if (!text) {
        showError(
          'Enter a monogram for every item with monogramming selected.'
        );
        input.focus();
        return null;
      }

      return text;
    }

    function groupItems(items) {
      var grouped = new Map();

      items.forEach(function (item) {
        var properties = item.properties || {};
        var sortedProperties = {};

        Object.keys(properties).sort().forEach(function (key) {
          sortedProperties[key] = properties[key];
        });

        var key = JSON.stringify({
          id: item.id,
          properties: sortedProperties,
          selling_plan: item.selling_plan || null
        });

        if (grouped.has(key)) {
          grouped.get(key).quantity += item.quantity;
        } else {
          grouped.set(key, {
            ...item,
            properties: sortedProperties
          });
        }
      });

      return Array.from(grouped.values());
    }

    async function addItems(event, button) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (busy) return;

      clearError();
      update();

      var quantity = quantityValue();
      var wallet = selectedWalletVariant();

      if (quantity === null) {
        showError('Enter a whole-number wallet quantity of at least 1.');
        var quantityField = form.querySelector('[name="quantity"]');
        if (quantityField) quantityField.focus();
        return;
      }

      if (!wallet || !wallet.available) {
        showError('Choose an available wallet option.');
        return;
      }

      var selected = selectedBelts();

      var incomplete = selected.find(function (card) {
        var select = card.querySelector('[data-sl-belt-variant]');
        var option = select.options[select.selectedIndex];

        return !select.value || !option || option.disabled;
      });

      if (incomplete) {
        showError('Choose an available option for every selected belt.');
        incomplete.querySelector('[data-sl-belt-variant]').focus();
        return;
      }

      var units = walletUnits();

      if (units.length !== quantity) {
        showError('Wallet quantity could not be confirmed. Reload and try again.');
        return;
      }

      var walletMonograms = [];

      for (var index = 0; index < units.length; index += 1) {
        var walletText = validateMonogram(units[index]);
        if (walletText === null) return;
        walletMonograms.push(walletText);
      }

      var beltMonograms = [];

      for (var beltIndex = 0; beltIndex < selected.length; beltIndex += 1) {
        var beltText = validateMonogram(
          selected[beltIndex].querySelector('[data-sl-monogram-unit]')
        );

        if (beltText === null) return;
        beltMonograms.push(beltText);
      }

      if (!form.reportValidity()) return;

      var data = new FormData(form);
      var baseProperties = {};
      var unsupportedFile = false;

      data.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (!match || match[1] === 'Monogram') return;

        if (typeof value === 'string') {
          if (value !== '') baseProperties[match[1]] = value;
        } else if (value && value.size > 0) {
          unsupportedFile = true;
        }
      });

      if (unsupportedFile) {
        showError('This test version does not support file-upload customizations.');
        return;
      }

      var sellingPlan = data.get('selling_plan');
      var items = [];
      var feeQuantity = 0;

      walletMonograms.forEach(function (text) {
        var properties = { ...baseProperties };

        if (text) {
          properties.Monogram = text;
          feeQuantity += 1;
        }

        var item = {
          id: Number(wallet.id),
          quantity: 1,
          properties: properties
        };

        if (sellingPlan) item.selling_plan = sellingPlan;
        items.push(item);
      });

      selected.forEach(function (card, index) {
        var select = card.querySelector('[data-sl-belt-variant]');
        var text = beltMonograms[index];
        var properties = {};

        if (text) {
          properties.Monogram = text;
          feeQuantity += 1;
        }

        items.push({
          id: Number(select.value),
          quantity: 1,
          properties: properties
        });
      });

      items = groupItems(items);

      if (feeQuantity > 0) {
        items.unshift({
          id: feeVariantId,
          quantity: feeQuantity
        });
      }

      busy = true;
      root.setAttribute('aria-busy', 'true');

      var wasDisabled = button ? button.disabled : false;
      if (button) button.disabled = true;

      var routeRoot =
        window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      try {
        var response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        var result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'The products could not be added.'
          );
        }

        window.location.assign(routeRoot + 'cart');
      } catch (error) {
        showError(
          (error.message || 'We could not confirm the addition.') +
          ' Check your cart before trying again.'
        );

        busy = false;
        root.removeAttribute('aria-busy');
        if (button) button.disabled = wasDisabled;
      }
    }
var oldCheck = form.querySelector('#sl-checkbox');
var oldInput = form.querySelector('#sl-input');
var originalMonogramPrice = form.querySelector(
  '#sl-wrap .sl-price'
);

if (originalMonogramPrice) {
  originalMonogramPrice.textContent =
    '(+' + money(feePrice) + ')';
}



    if (oldCheck && oldCheck.checked) {
      walletStates[0] = {
        checked: true,
        text: oldInput ? cleanMonogram(oldInput.value) : ''
      };
    }

    update();

  
    // Prevent accelerated checkout from bypassing customization.
    var paymentButton = form.querySelector('.shopify-payment-button');
    if (paymentButton) paymentButton.style.display = 'none';

    if (trigger && beltOptions) {
      trigger.addEventListener('click', function () {
        if (busy) return;

        var open = trigger.getAttribute('aria-expanded') !== 'true';

        trigger.setAttribute('aria-expanded', String(open));
        beltOptions.hidden = !open;

        if (!open) {
          beltCards.forEach(function (card) {
            card.querySelector('[data-sl-belt-check]').checked = false;
          });
        }

        clearError();
        update();
      });
    }

    form.addEventListener('input', function (event) {
      if (event.target.matches('[data-sl-monogram-text]')) {
        event.target.value = cleanMonogram(event.target.value);
      }

      update();
    });

    form.addEventListener('change', function () {
      update();

      // Allow the theme's variant selector to finish updating its hidden ID.
      setTimeout(function () {
        if (root.isConnected) update();
      }, 0);
    });

    document.addEventListener('click', function (event) {
      if (!root.isConnected || !(event.target instanceof Element)) return;

      var button = event.target.closest('[name="add"]');
      if (!button || button.closest('form') !== form) return;

      addItems(event, button);
    }, true);

    document.addEventListener('submit', function (event) {
      if (!root.isConnected || event.target !== form) return;

      addItems(event, form.querySelector('[name="add"]'));
    }, true);

    var sizeDialog = root.querySelector('[data-sl-size-guide-dialog]');

if (sizeDialog) {
  root.querySelectorAll('[data-sl-size-guide-open]').forEach(
    function (button) {
      button.setAttribute('aria-haspopup', 'dialog');

      button.addEventListener('click', function () {
        if (!sizeDialog.open) {
          sizeDialog.showModal();
        }
      });
    }
  );

  var sizeClose = sizeDialog.querySelector(
    '[data-sl-size-guide-close]'
  );

  if (sizeClose) {
    sizeClose.addEventListener('click', function () {
      sizeDialog.close();
    });
  }

  sizeDialog.addEventListener('click', function (event) {
    if (event.target !== sizeDialog) return;

    var bounds = sizeDialog.getBoundingClientRect();
    var outside =
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;

    if (outside) {
      sizeDialog.close();
    }
  });
}

    root.dataset.slInitialized = 'true';
    root.hidden = false;
  }

  function initializeAll(scope) {
    scope.querySelectorAll('[data-sl-wallet-set]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
